<ng-template cdkPortal #actions="cdkPortal">
  <a class="btn btn-icon btn-secondary"
     [routerLink]="createPath"
     [queryParams]="query.filters">
    <icon-plus></icon-plus>
    <span class="ml-2">Add store collection</span>
  </a>
</ng-template>

<smart-table [headers]="headers"
             [source]="source"
             (filtersChange)="onSearch($event)"
             (sortChange)="onSort($event)"
             [collapseAuto]="false"
             [collapseByClick]="true"
             (collapsedChange)="initForm($event)">
<ng-template smartTableColumn="name" let-item>
  <td>
    <entity-link type="collection"
                 [item]="item"
                 [showInfo]="false"
                 [relativePath]="relativePath"
                 [isEntity]="isEntity">
    </entity-link>
  </td>
</ng-template>

<ng-template smartTableColumn="id" let-item>
  <td>
    {{ item.id }}
  </td>
</ng-template>

<ng-template smartTableColumn="createdAt" let-item>
  <td>
    {{ item.createdAt | moment }}
  </td>
</ng-template>

<ng-template smartTableColumn="updatedAt" let-item>
  <td>
    {{ item.updatedAt | moment }}
  </td>
</ng-template>

<ng-template smartTableColumn="active" let-item>
  <td>
    <badge-exist existText="Active" [item]="item.active"></badge-exist>
  </td>
</ng-template>


  <ng-template smartTableColumn="availableForDownloading" let-item>
    <td>
      <badge-exist existText="Available" [item]="item.availableForDownloading"></badge-exist>
    </td>
  </ng-template>

  <ng-template smartTableColumn="product" let-item>
    <td>
      <entity-link [showInfo]="false" type="product" [item]="item.product" [relativePath]="relativePath"></entity-link>
    </td>
  </ng-template>


  <ng-template smartTableColumn="projects" let-item>
    <td>
<!--      TODO tooltip with names-->
      <span>
        {{ item.projects.length }} project<ng-container *ngIf="item.projects?.length > 0">s</ng-container>
      </span>
<!--      <div [class.mb-1]="!last" *ngFor="let item of item.projects; let last = last">-->
<!--        <entity-link [showInfo]="false" type="project" [item]="item" [relativePath]="relativePath"></entity-link>-->
<!--      </div>-->
    </td>
  </ng-template>

<!--  <ng-template smartTableColumn="actions" let-item>-->
<!--    <td class="text-right text-nowrap">-->
<!--      <button class="btn btn-danger btn-square btn-icon" (click)="delete(item.id, 'collection', item.name)">-->
<!--        <icon-trash></icon-trash>-->
<!--      </button>-->
<!--    </td>-->
<!--  </ng-template>-->

  <ng-template smartTableCollapse let-item let-index="index" let-collapse="collapse">
    <form [formGroup]="forms[item.id]" (ngSubmit)="save(item, index)" novalidate>
      <div class="row">
        <div class="col-60">
          <div class="form-group">
            <label>Name</label>
            <form-group-simple name="name" placeholder="Name" formControlName="name"></form-group-simple>
          </div>
        </div>
        <div class="col-30">
          <div class="form-group">
            <label>Product</label>
            <form-group-select entity="product"
                               bindLabel="name"
                               bindValue="id"
                               [storeQuery]="{parentStore: storeData}"
                               [searchable]="true"
                               placeholder="Product"
                               formControlName="product">
            </form-group-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-30">
          <div class="form-group">
            <label>Projects</label>
            <form-group-select entity="project"
                               bindLabel="name"
                               bindValue="id"
                               [storeQuery]="{store: storeData}"
                               [multiple]="true"
                               [searchable]="true"
                               placeholder="Projects"
                               formControlName="projects">
            </form-group-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-auto">
          <div class="form-group">
            <form-group-simple type="checkbox" name="active" formControlName="active">Active</form-group-simple>
          </div>
        </div>
        <div class="col-auto">
          <div class="form-group">
            <form-group-simple type="checkbox" name="availableForDownloading" formControlName="availableForDownloading">Available For Downloading</form-group-simple>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-auto">
<!--          <btn-delete form actions type="store collection"-->
<!--                      [name]="item.name"-->
<!--                      (delete)="delete($event, item.id)">-->
<!--          </btn-delete>-->
        </div>
        <div class="col-auto ml-auto">
          <div class="m-n2">
            <button class="btn btn-success m-2" type="submit" [disabled]="forms[item.id].disabled">
              Save
            </button>
            <button class="btn btn-outline-info m-2" type="button"
                    (click)="cancel(collapse)">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </form>
  </ng-template>
</smart-table>

<pagination [itemsOnPage]="pagination.limit"
            [page]="pagination.currentPage"
            (pageChanged)="setPage($event)"
            [itemsFull]="pagination.fullCount"></pagination>

<preloader [hidden]="!loaderService.isLoading"></preloader>

